<script>
    import confirmationPages from "../confirmationPages";
    import { projectSettings } from '../../config';
    import model from "../../stores/modelStore";
    import reviewAndSignModel from "../../stores/reviewAndSignStore";
    import { isValid } from "../../validation";
    import { formatDateTime, formatDate, utcNow } from "../../helpers/dateHelpers";

    import Form from '../../components/Form.svelte';
    import FormRow from '../../components/FormRow.svelte';
    import FormColumn from '../../components/FormColumn.svelte';
    import ReviewSectionHeader from "../../components/ReviewSectionHeader.svelte";
    import TextInput from "../../components/TextInput.svelte";
    import DatePicker from "../../components/DatePicker.svelte";
    import Checkbox from "../../components/Checkbox.svelte";
    import NavigationButtons from "../../components/NavigationButtons.svelte";

    export let pageTitle = null;
	export let persistUrl = null;

	let buttons = null;
    let disabled = true;
    let tellingTruth = false;
    let consent = false;
    let signatureRequired = true;
    let signature = null;
    let signatureDate = null;
    let disableSubmit = true;

    document.title = `${projectSettings.classActionName} - Review`;

    $reviewAndSignModel.signatureDate = formatDate(new Date());

    // Check if there is a function to call in routes.js which will determine if a page is to be shown,
    // otherwise just show it.
    const displayComponent = (page) => {
        if (page && page.confirmationAvoid === "true"){
            // don't show this page on confirmation screen, ONLY in review
            return false;
        }

        if (page && page.showComponent && (typeof page.showComponent === "function")){
            return page.showComponent($model);
        }
        return true;
    }

    const preSubmit = () => {
        $reviewAndSignModel.tellingTruth = tellingTruth ? "true" : "false";
        $reviewAndSignModel.consent = consent ? "true" : "false";

        if ($model.bankDetails && $model.bankDetails.completedbyShine){
            $reviewAndSignModel.claimantWrittenConfirmation  = true;
        }

    }

    const handleSubmit = async (e) => {
    	buttons.blockNext();

        let errors = isValid();

        if (!errors.length) {
            preSubmit();

		    let response = await reviewAndSignModel.saveModelAsync(persistUrl);

		    if (!response.success) {
			    console.log(response);
		    } else {
			    buttons.next();
		    }
            
		} else {
			errors[0].scrollIntoView({ behavior: "smooth" });
		}

		buttons.unblock();
    };

    $:{
        if (tellingTruth && consent && $reviewAndSignModel.signature){
            disableSubmit = false;
        }else{
            disableSubmit = true;
        }
    }
</script>

<section>
<Form id="form-confirmation-signature-details" on:submit={handleSubmit}>
    <FormRow class="justify-content-center">
        <FormColumn>
            <h1 class="text-center">{@html projectSettings.classActionName}</h1>
        </FormColumn>
    </FormRow>

    <div class="confirmation">
        {#each confirmationPages as page}
            {#if displayComponent(page)}
        	    <ReviewSectionHeader heading={page.confirmationHeading}></ReviewSectionHeader>

                <svelte:component this={page.component} {...page} {disabled} />
            {/if}
        {/each}
    </div>

    <FormRow>
        <div class="col-md-8 col-sm-12">
            <Checkbox required="{signatureRequired}"
                        bind:checked="{tellingTruth}"
                        label="I am telling the truth about the information I have completed in this Registration Form."
                        id="confirmation"></Checkbox>
        </div>
    </FormRow>
    <FormRow>
        <div class="col-md-8 col-sm-12">
            <Checkbox required="{signatureRequired}"
                        bind:checked="{consent}"
                        label="I expressly consent to this method of acceptance in accordance with <u>s10 of the Electronic Transactions Act 2011 (WA)</u>"
                        id="consentAcceptance"></Checkbox>
        </div>
    </FormRow>

    <FormRow>
        <FormColumn cols="8">
            <TextInput
                required={true}
                disabled={false}
                id="signature"
                label="Claimant's signature"
                placeholder="Please type your full name"
                bind:value={$reviewAndSignModel.signature}/>
        </FormColumn>
        <FormColumn cols="4">
            <DatePicker
                disabled={true}
                label="Date"
                validator={true}
                end={new Date()}
                placeholder="e.g. 01/05/1987"
                bind:formattedSelected={$reviewAndSignModel.signatureDate}
                openOnClass="calendar-icon"
                />
        </FormColumn>
    </FormRow>

    <FormRow class="confirmation-hide">
		<FormColumn>
			<NavigationButtons bind:buttons
                disableNext={disableSubmit}
				nextPageLabel={"Submit"} />
		</FormColumn>
	</FormRow>
</Form>
</section>
